// Generated file, do not modify, run `yarn import-locales` to refresh

/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

// Turn of type checking, as we want to allow "any" types for the i18n keys.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const da_DK = {
  datePickerDialogMonthUnspecified: `(Uspecificeret)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Måned`,
  clearButton: `Ryd valg`,
  datePickerDialogYearListLabel: `Vælg år`,
  datePickerDialogMonthListLabel: `Vælg måned`,
  datePickerUnderflow: args => `Værdien skal være ${args.minValue} eller senere.`,
  datePickerOverflow: args => `Værdien skal være ${args.maxValue} eller tidligere.`,
  loading: `Loader...`,
  dateRangeFrom: args => `fra, ${args.label}`,
  dateRangeTo: args => `til, ${args.label}`
};
const de_DE = {
  datePickerDialogMonthUnspecified: `(Nicht spezifiziert)`,
  datePickerDialogTabYear: `Jahr`,
  datePickerDialogTabMonth: `Monat`,
  clearButton: `Auswahl löschen`,
  datePickerDialogYearListLabel: `Jahr auswählen`,
  datePickerDialogMonthListLabel: `Monat auswählen`,
  datePickerUnderflow: args => `Der Wert muss ${args.minValue} oder höher sein.`,
  datePickerOverflow: args => `Der Wert muss ${args.maxValue} oder früher sein.`,
  loading: `Geladen…`,
  dateRangeFrom: args => `von, ${args.label}`,
  dateRangeTo: args => `an, ${args.label}`
};
const en_GB = {
  datePickerDialogMonthUnspecified: `(Unspecified)`,
  datePickerDialogTabYear: `Year`,
  datePickerDialogTabMonth: `Month`,
  clearButton: `Clear selection`,
  datePickerDialogYearListLabel: `Select year`,
  datePickerDialogMonthListLabel: `Select month`,
  datePickerUnderflow: args => `Value must be ${args.minValue} or later.`,
  datePickerOverflow: args => `Value must be ${args.maxValue} or earlier.`,
  loading: `Loading…`,
  dateRangeFrom: args => `from, ${args.label}`,
  dateRangeTo: args => `to, ${args.label}`
};
const en_US = {
  datePickerDialogMonthUnspecified: `(Unspecified)`,
  datePickerDialogTabYear: `Year`,
  datePickerDialogTabMonth: `Month`,
  clearButton: `Clear selection`,
  datePickerDialogYearListLabel: `Select year`,
  datePickerDialogMonthListLabel: `Select month`,
  datePickerUnderflow: args => `Value must be ${args.minValue} or later.`,
  datePickerOverflow: args => `Value must be ${args.maxValue} or earlier.`,
  loading: `Loading…`,
  dateRangeFrom: args => `from, ${args.label}`,
  dateRangeTo: args => `to, ${args.label}`
};
const fr_FR = {
  datePickerDialogMonthUnspecified: `(Indéterminé)`,
  datePickerDialogTabYear: `Année`,
  datePickerDialogTabMonth: `Mois`,
  clearButton: `Effacer la sélection`,
  datePickerDialogYearListLabel: `Sélectionnez l'année`,
  datePickerDialogMonthListLabel: `Sélectionnez le mois`,
  datePickerUnderflow: args => `La valeur doit être ${args.minValue} ou ultérieure.`,
  datePickerOverflow: args => `La valeur doit être ${args.maxValue} ou antérieure.`,
  loading: `Chargement…`,
  dateRangeFrom: args => `de, ${args.label}`,
  dateRangeTo: args => `à, ${args.label}`
};
const no_NO = {
  datePickerDialogMonthUnspecified: `(Uspesifisert)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Måned`,
  clearButton: `Fjern valg`,
  datePickerDialogYearListLabel: `Velg år`,
  datePickerDialogMonthListLabel: `Velg måned`,
  datePickerUnderflow: args => `Verdien må være ${args.minValue} eller senere.`,
  datePickerOverflow: args => `Verdien må være ${args.maxValue} eller tidligere.`,
  loading: `Laster inn…`,
  dateRangeFrom: args => `fra, ${args.label}`,
  dateRangeTo: args => `til, ${args.label}`
};
const sv_SE = {
  datePickerDialogMonthUnspecified: `(Ospecificerad)`,
  datePickerDialogTabYear: `År`,
  datePickerDialogTabMonth: `Månad`,
  clearButton: `Rensa valet`,
  datePickerDialogYearListLabel: `Välj år`,
  datePickerDialogMonthListLabel: `Välj månad`,
  datePickerUnderflow: args => `Värdet måste vara ${args.minValue} eller senare.`,
  datePickerOverflow: args => `Värdet måste vara ${args.maxValue} eller tidigare.`,
  loading: `Laddar…`,
  dateRangeFrom: args => `från, ${args.label}`,
  dateRangeTo: args => `till, ${args.label}`
};
const locales = {
  "da-DK": da_DK,
  "de-DE": de_DE,
  "en-GB": en_GB,
  "en-US": en_US,
  "fr-FR": fr_FR,
  "no-NO": no_NO,
  "sv-SE": sv_SE
};
export default locales;
//# sourceMappingURL=locales.js.map